import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRICS]: {
		url:'/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/:calculationVolumeMetricId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/:calculationVolumeMetricId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/:calculationVolumeMetricId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].CREATE_DONE_WORKS_CALCULATION_VOLUME_METRIC]: {
		url:'/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/:calculationVolumeMetricId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_INTERVALS]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/:calculationVolumeMetricId/intervals/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_BULK_UPDATE]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/bulk_update/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PUT_DONE_WORKS_CALCULATION_VOLUME_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/:calculationVolumeMetricId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].DELETE_DONE_WORKS_CALCULATION_VOLUME_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_volume_metrics/:calculationVolumeMetricId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}